/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Subscription_Expired_LinkInputs */

const cs_billing_subscription_expired_link = /** @type {(inputs: Billing_Subscription_Expired_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít fakturaci`)
};

const en_billing_subscription_expired_link = /** @type {(inputs: Billing_Subscription_Expired_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open billing`)
};

/**
* | output |
* | --- |
* | "Open billing" |
*
* @param {Billing_Subscription_Expired_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_subscription_expired_link = /** @type {((inputs?: Billing_Subscription_Expired_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Subscription_Expired_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_subscription_expired_link(inputs)
	return cs_billing_subscription_expired_link(inputs)
});